export default file => ({
  id: file.id,
  filename: file.label,
  dir: file.dir,
  url: file.url,
  createdAt: file.created_at,
  updatedAt: file.updated_at,
  mime: file.mime,
  fileSize: file?.metadata?.size,
  type: file.type,
});
